import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getData } from "../../../../ApiServices/ApiService";
import { ORG_GET_CLIENT_TO_DO_LIST } from "../../../../ApiServices/BaseURL";
import { useTheme } from "../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../Utils/Exception";

const ClientToDoListController = () => {
  const [toDoList, setToDoList] = useState([]);
  const [expandedTasks, setExpandedTasks] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { setIsLoginPopup } = useTheme();
  const location = useLocation();
  const clientId = location.state?.clientId || "";

   const pageName = 'ClientTodolistController';
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

  useEffect(() => {
    if (!clientId) {
      setError("Client ID is missing.");
      setLoading(false);
      return;
    }

    const fetchComments = async () => {
      try {
        setLoading(true);
        setError("");
        setToDoList([]);
        const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));
        if (!storedUserInfo?.emp_id) {
          setError("User information is missing.");
          setLoading(false);
          return;
        }

        const response = await getData(`${ORG_GET_CLIENT_TO_DO_LIST}?emp_id_auth=${storedUserInfo?.emp_id}&client_id=${clientId}`);
        const responseData = await response.json();

        if (response?.status === 200) {
          if (responseData?.statusCode === 200) {
            if (responseData?.message.toLowerCase() === 'success') {
              if (responseData?.dataJ?.length > 0) {
                setToDoList(responseData?.dataJ || []);
              } else {
                setError(responseData?.info || 'No To-Do List Available');
                logFrontendException(storedUserId, pageName, "commentsfetch", responseData?.info || '');
              }
            } else {
              setError(responseData?.info || 'Failed to fetch To-Do List. Please try again.');
              logFrontendException(storedUserId, pageName, "commentsfetch", responseData?.info || '');
            }
          } else {
            setError(responseData?.info || 'Failed to fetch To-Do List.');
            logFrontendException(storedUserId, pageName, "commentsfetch", responseData?.info || '');
          }
        }
        // Token-related errors: 400, 401, 403
        else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
          
            setError('Unauthorized access. Your session may have expired. Please log in again.');
            logFrontendException(storedUserId, pageName, "commentsfetch", responseData || '');
            // Optionally, redirect to the login page or refresh the token
            // Example: redirectToLogin();
          
          setIsLoginPopup(true)
        }
        // Internal Server Error: 500
        
        // Unexpected or network-related errors
        else {
          setError('Unexpected error occurred. Please try again later.');
          logFrontendException(storedUserId, pageName, "commentsfetch", responseData || '');
        }
      } catch (error) {
        
          // An error occurred in setting up the request
          setError(`Failed to fetch To-Do List. Please check your network connection and try again.`);
          logFrontendException(storedUserId, pageName, "commentsfetch-catch", error || '');
        
      } finally {
        setLoading(false);
      }
    };

    fetchComments();
  }, [clientId]);

  const handleToggleDetails = (taskId) => {
    setExpandedTasks((prev) => ({
        ...prev,
        [taskId]: !prev[taskId],
    }));
};

  return {
    toDoList,
    expandedTasks,
    handleToggleDetails,
    loading,
    error,
  };
};

export default ClientToDoListController;
